(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('WorkingDayDeleteController',WorkingDayDeleteController);

    WorkingDayDeleteController.$inject = ['$uibModalInstance', 'entity', 'WorkingDay'];

    function WorkingDayDeleteController($uibModalInstance, entity, WorkingDay) {
        var vm = this;
        vm.workingDay = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WorkingDay.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
